module.exports = __webpack_public_path__ + "img/workContents02_pc_02.3a8cd9e6.png";